module.exports = __webpack_public_path__ + "img/timmer-tooltip-background.582cf53b.jpg";